export default __webpack_public_path__ + "static/10.03-7-65eb35753f4760ece18f745d2bb123ee.png";